// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { setMonth as fn } from "../setMonth.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const setMonthWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default setMonthWithOptions;
